"use client";

import { useEffect } from "react";
import { loadPaddle, paddleConfigured } from "@/lib/paddle";

/**
 * Paddle's "Default payment link" is https://rankbist.com. Links Paddle itself sends (invoices, payment
 * recovery and "update your card" emails) open that address with ?_ptxn=txn_… . Paddle.js opens the checkout
 * for that transaction by itself as soon as it is initialised, so on those visits it is loaded straight away.
 * Every other visit is untouched (Paddle.js still loads only when someone starts a checkout).
 */
export function PaddleLinkCheckout() {
  useEffect(() => {
    if (!paddleConfigured) return;
    const txn = new URLSearchParams(window.location.search).get("_ptxn");
    if (txn && /^txn_[a-z0-9]+$/i.test(txn)) void loadPaddle();
  }, []);
  return null;
}
